'use strict';

exports.__esModule = true;
exports.default = undefined;
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Iovation = function (_Component) {
  (0, _inherits3.default)(Iovation, _Component);
  function Iovation() {
    (0, _classCallCheck3.default)(this, Iovation);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }
  Iovation.prototype.componentDidMount = function componentDidMount() {
    this.insertIovationScript();
    this.startWatchingValue();
  };
  Iovation.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopWatchingValue();
    this.removeIovationScript();
  };
  Iovation.prototype.stopWatchingValue = function stopWatchingValue() {
    if (!this.watchIntervalId) return;
    clearInterval(this.watchIntervalId);
    this.watchIntervalId = null;
  };
  Iovation.prototype.startWatchingValue = function startWatchingValue() {
    var _this2 = this;
    var _props = this.props,
      onChange = _props.onChange,
      value = _props.value;
    this.watchIntervalId = setInterval(function () {
      var newValue = _this2.refs.blackBox && _this2.refs.blackBox.value;
      if (!newValue) return;
      _this2.stopWatchingValue();
      if (newValue === value) return;
      onChange(newValue);
    }, 100);
  };
  Iovation.prototype.insertIovationScript = function insertIovationScript() {
    /* eslint-disable camelcase */
    window.io_bbout_element_id = 'io-black-box';
    window.io_install_stm = false;
    window.io_exclude_stm = 12;
    window.io_install_flash = false;
    window.io_enable_rip = true;
    /* eslint-enable */

    this.scriptNode = document.createElement('script');
    this.scriptNode.src = 'https://mpsnare.iesnare.com/snare.js';
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(this.scriptNode, firstScript);
  };
  Iovation.prototype.removeIovationScript = function removeIovationScript() {
    if (!this.scriptNode) return;
    if (this.scriptNode.parentNode) this.scriptNode.parentNode.removeChild(this.scriptNode);
    this.scriptNode = null;
  };
  Iovation.prototype.render = function render() {
    return _react2.default.createElement('input', {
      type: 'hidden',
      id: 'io-black-box',
      ref: 'blackBox'
    });
  };
  return Iovation;
}(_react.PureComponent);
Iovation.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string
};
Iovation.scriptNode = null;
Iovation.watchIntervalId = null;
exports.default = Iovation;
module.exports = exports['default'];